import * as types from '../mutation-types'

const getDefaultState = () => {
  return {
    selected: null,
    lawFirms: {}
  }
}

let state = getDefaultState()

const getters = {
  selectOptions: state => {
    const keys = Object.keys(state.lawFirms)

    let options = []
    keys.forEach(key => {
      options.push({ id: state.lawFirms[key].id, name: state.lawFirms[key].name })
    })

    return options.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
  }
}

// noinspection JSUnusedGlobalSymbols
const actions = {
  updateSelectedLawFirm ({ commit }, id) {
    commit(types.LAW_FIRMS.UPDATE_SELECTED, id)
  },
  initLawFirms ({ commit }, lawFirms) {
    commit(types.LAW_FIRMS.INIT, lawFirms)

    let idsLawFirm = Object.keys(lawFirms)

    // if user is linked at only one law firm, this law firm is automatically selected
    if (idsLawFirm.length === 1) {
      commit(types.LAW_FIRMS.UPDATE_SELECTED, idsLawFirm[0])
    }
  },
  resetLawFirms ({ commit }) {
    commit(types.LAW_FIRMS.RESET)
  }
}

const mutations = {
  [types.LAW_FIRMS.UPDATE_SELECTED] (state, id) {
    state.selected = parseInt(id, 10)
  },
  [types.LAW_FIRMS.INIT] (state, lawFirms) {
    state.lawFirms = lawFirms
  },
  [types.LAW_FIRMS.RESET] (state) {
    Object.assign(state, getDefaultState())
  }
}

// noinspection JSUnusedGlobalSymbols
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
